module.exports = __webpack_public_path__ + "static/media/bg-bottom-mountains.cb781f78.png";